import React from 'react'
import { withDeleteTransaction } from 'tennders-transactions/hocs/withDeleteTransaction'
import IconDelete from '../../../../public/icons/icon-delete.svg'

const DeleteButton = () => (
  <IconDelete />
)

export default withDeleteTransaction(DeleteButton)
